import React, { useEffect, useRef, useState } from "react";
import { Globals } from "../../global/Globals";
import GenericHeader from "../../components/GenericHeader/GenericHeader";
import "./AddNewUser.css";
import DropdownList from "../../components/DropdownList/DropdownList";
import { checkUserEmailExistance, validatePhoneNumber } from "../../util/util";
import PopUp from "../../components/PopUp/PopUp";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchByfilter, fetchAllRoles } from "../../services/GenericAPI";
import { fetchFilterByCreatedBynewUser } from "../../services/dashboardAPI";
import {
  setAllClusters,
  setAllReporting,
  setAllRoles,
} from "../SignUp/ProducerRegistrationSlice";
import { useDispatch, useSelector } from "react-redux";
import { createUserApi } from "../../services/api";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import { useLanguage } from "../../context/Languagecontext";
import { Globals as OldGlobals } from "../../global/Globals";

const AddNewUser = () => {
  const { Globals, languages, setLanguages } = useLanguage();
  const location = useLocation();
  const { activeHeader } = location.state || "";
  const dropdownRefs = useRef({});
  const [inputs, setInputs] = useState({
    name: "",
    email: "",
    designation: "",
    reporting: "",
    phoneNumber: "",
    location: "",
  });
  const [roleValue, setRoleValue] = useState("");
  const [selectedRole,setSelectedRole]=useState({isSysAdmin:false, isInternalUser:false, isHopUser: false});
  const [isLocationInvalid, setIsLocationInvalid] = useState(false);
  const [validMail, setValidMail] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isButtonActivate, setIsButtonActivate] = useState(false);
  const [isNameInvalid, setIsNameInvalid] = useState(false);
  const [validDesignation, setValidDesignation] = useState(true);
  const [validCluster, setValidCluster] = useState(true);
  const [validReportingTo, setValidReportingTo] = useState(true);
  const [isPhoneInValid, setIsPhoneInValid] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(false);
  const [isDesignationVisited, setIsDesignationVisited] = useState(false);
  const [isClusterVisited, setIsClusterVisited] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [newRoleId, setNewRoleId] = useState([]);
  const [matchingObject, setMatchingObject] = useState("");
  const [dropdownState, setDropdownState] = useState({
    activeDropdown: false,
    dropdowns: {
      DESIGNATIONS:{ selected: [], selectedText: [] },
      CLUSTERS:{ selected: [], selectedText: [] }
    },
  });
   
  const allClusterList = useSelector(
    (state) => state.producerRegistration.allClusters
  );
  const allRolesData = useSelector(
    (state) => state.producerRegistration.allRoles
  );
  const allreportingData = useSelector(
    (state) => state.producerRegistration.allReporting
  );
  const allClustersData = allClusterList?.map((cluster) => cluster.name);
  const allRoleList = allRolesData?.filter((role) => role.roleId !== 6).map((role) => ({
    id: role.roleId,
    name: role.roleName
  }));
  const reportingData = allreportingData?.map((val) => val.name);
  const [popUpState, setPopUpState] = useState({
    open: false,
    title: "",
    text: "",
    negativeAction: null,
    normalAction: null,
    negativeActionText: "",
    normalActionText: "",
  });
  const clusterAllowedRoles = [
    Globals.USER_ROLES.CE,
    Globals.USER_ROLES.CC,
    Globals.USER_ROLES.PRODUCER,
    Globals.USER_ROLES.SNR_MGR,
  ].includes(newRoleId?.toString());
  const reportingToAllowedRoles = [
    Globals.USER_ROLES.CE,
    Globals.USER_ROLES.CC,
    Globals.USER_ROLES.PRODUCER,
  ].includes(newRoleId?.toString());

  const gotoHome = (data) => {
    navigate(Globals.NAVPATH.HOME, {
      state: {
        activeHeader: activeHeader,
        toastValue: data,
        activeTabData: OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT,
      },
    });
  };

  const CreateUser = (body) => {
    createUserApi(body)
      .then((response) => {
        response.data.status === "OK"
          ? gotoHome({
              open: true,
              status: "success",
              title: Globals.ADD_NEW_USER_SUCCESS_TOAST,
            })
          : openPopUp("failed");
      })
      .catch((error) => {
        console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
        openPopUp("failed");
      });
  };
  const openPopUp = (popUpType) => {
    const requestBody = {
      name: inputs.name?.trim() || "", // Assuming firstName is part of inputs
      email: inputs.email || "",
      cluster: selectedRole.isSysAdmin===true?[]:dropdownState.dropdowns.CLUSTERS.selected || [], // Assuming cluster has an ID property
      phoneNumber: inputs.phoneNumber || "",
      designation: selectedRole.isSysAdmin===true?['1']: selectedRole.isHopUser===true? ['6'] : dropdownState.dropdowns.DESIGNATIONS.selected || [],//inputs.designation ? [newRoleId] : [], // Assuming designation corresponds to roles
      location: inputs.location?.trim() || "",
      ...(matchingObject && { reportingTo: matchingObject }),
    };
    switch (popUpType) {
      case "abort":
        setPopUpState({
          open: true,
          title: Globals.ADD_USER.ABORT_POPUP_TITLE,
          text: Globals.ADD_USER.ABORT_POPUP_MESSAGE,
          negativeAction: gotoHome,
          negativeActionText: Globals.ADD_USER.ABORT_BUTTON_TEXT,
        });
        break;
      case "submit":
        setPopUpState({
          open: true,
          title: Globals.ADD_USER.TITLE,
          text: Globals.ADD_USER.POPUP_MESSAGE,
          normalAction: () => CreateUser(requestBody),
          normalActionText: Globals.ADD_USER.FOOTER_BTN_TITLE,
        });
        break;
      case "failed":
        setPopUpState({
          open: true,
          title: Globals.ADD_USER.FAILURE_POPUP_TITLE,
          text: Globals.ADD_USER.FAILURE_POPUP_MESSAGE,
          normalAction: () => CreateUser(requestBody),
          normalActionText: Globals.ADD_USER.FAILURE_BUTTON_TEXT,
          popupType: popUpType,
        });
        break;
    }
  };

  const handlePhoneNumber = (event) => {
    setIsPhoneInValid(false);
    const phNumber = event.target.value;
    setInputs((prevInputs) => ({ ...prevInputs, phoneNumber: phNumber }));
    phNumber.length > 0
      ? setIsPhoneInValid(!validatePhoneNumber(phNumber))
      : setIsPhoneInValid(true);
  };

  const checkForEmptyNumber = () => {
    if (inputs.phoneNumber.trim() === "") {
      setIsPhoneInValid(true);
    } else {
      const res = validatePhoneNumber(inputs.phoneNumber);
      setIsPhoneInValid(!res);
    }
  };

  useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
  }, []);

  useEffect(() => {
    if (allClustersData || allClustersData.length === 0) {
      fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME.CLUSTERS).then((response) => {
        dispatch(
          setAllClusters({
            allClusters:
              response.data.content[OldGlobals.FILTER_OPTIONS_NAME.CLUSTERS],
          })
        );
      });
    }
    getAllRoles();
    return () => {
      dispatch(setAllReporting([]));
    };
  }, []);

  useEffect(() => {
    dropdownState.dropdowns.CLUSTERS.selected?.length &&
      getFilteredByCreatedBy(dropdownState.dropdowns.CLUSTERS.selected);
  }, [dropdownState.dropdowns?.CLUSTERS?.selected]);

  const getAllRoles = async () => {
    try {
      const response = await fetchAllRoles();
      const result=response.data.content.filter((item) => item.roleId!==1 && item.roleName!=="System Admin");
      dispatch(setAllRoles(result));
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
  const getFilteredByCreatedBy = async (clusterId) => {
    dispatch(setAllReporting([]));
    fetchFilterByCreatedBynewUser(
      [Number(Globals.USER_ROLES.SNR_MGR), Number(Globals.USER_ROLES.HOP)],
      clusterId
    ) //roleid and clusterid should pass as array
      .then((response) => {
        dispatch(setAllReporting(response.data.content));
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
      });
  };

  const validateEmail = (e) => {
    const value = e.target.value;
    setInputs((prevInputs) => ({ ...prevInputs, email: value }));

    if (value.length === 0) {
      setValidMail(false);
      setErrorMessage(Globals.ERROR_MESSAGES.REG_EMPTY_EMAIL);
      return;
    }

    const emailRegex = OldGlobals.REGEX.EMAIL_REGEX;
    const isValidEmail = emailRegex.test(value);

    if (!isValidEmail) {
      setValidMail(false);
      setErrorMessage(Globals.ERROR_MESSAGES.INVALID_EMAIL_FORMAT);
      return;
    }
    else{
      setErrorMessage("");
      setValidMail(true);
    }
    checkUserEmailExistance(value, setValidMail, setErrorMessage);
  };

  //This code to validate all mandatory fields and enabled button accordingly
    useEffect(() => {
      if (selectedRole?.isSysAdmin === true) {
        if (inputs.name.length > 0 &&
          inputs.email.length > 0 &&
          inputs.phoneNumber.length > 0 &&
          inputs.location.length > 0 &&
          validMail&&
          !isNameInvalid &&
          !isPhoneInValid &&
          !isLocationInvalid
        ) {
          setIsButtonActivate(true);
        }
        else {
          setIsButtonActivate(false);
        }
      }
      if (selectedRole?.isInternalUser === true) {
        const isSeniorManager = (dropdownState.dropdowns.DESIGNATIONS.selected.includes('2'));
        const isReportingValid = isSeniorManager
          ? inputs.reporting.length === 0
          : inputs.reporting.length > 0;
          if(isSeniorManager){
            inputs.reporting="";
          }
        if (
          inputs.name.length > 0 &&
          inputs.email.length > 0 &&
          inputs.phoneNumber.length > 0 &&
          inputs.location.length > 0 &&
          (dropdownState.dropdowns.DESIGNATIONS.selected.length > 0) &&
          dropdownState.dropdowns.CLUSTERS.selected.length > 0 &&
          ((isSeniorManager&&inputs.reporting.length===0) || isReportingValid)&&
          //isReportingValid &&
          !isNameInvalid &&
          validMail&&
          !isPhoneInValid &&
          !isLocationInvalid &&
          validDesignation &&
          validCluster
        ) {
          setIsButtonActivate(true);
        } else {
          setIsButtonActivate(false);
        }
      }
      if (selectedRole?.isHopUser === true) {
        if (inputs.name.length > 0 &&
          inputs.email.length > 0 &&
          inputs.phoneNumber.length > 0 &&
          inputs.location.length > 0 &&
          dropdownState.dropdowns.CLUSTERS.selected.length > 0 &&
          validMail&&
          !isNameInvalid &&
          !isPhoneInValid &&
          !isLocationInvalid
        ) {
          setIsButtonActivate(true);
        }
        else {
          setIsButtonActivate(false);
        }
      }
    });

  const handleUserName = (event) => {
    const name = event.target.value;
    setIsNameInvalid(name.length === 0);
    setInputs((prevInputs) => ({
      ...prevInputs,
      name,
    }));
  };

  const handleLocation = (event) => {
    const location = event.target.value;
    setIsLocationInvalid(location.length === 0);
    setInputs((prevInputs) => ({
      ...prevInputs,
      location,
    }));
  };

  const handletog = (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    if(dropdownName==="DESIGNATIONS"){
      setIsDesignationVisited(true);
    }
    if(dropdownName==="CLUSTERS"){
      setIsClusterVisited(true);
    }
  };
 
  const handleSelectAll = (dropdownName,selectAll, options) => {
    const selectedDataSting = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));
    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: {
          ...prev.dropdowns[dropdownName],
        selected: selectAll ? selectedDataSting : [],
        selectedText: selectAll ? selectedDataText : [],
      },
    }
    }));
    setMatchingObject("");
  };

  const handleSelect = (dropdownName,value) => {
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns[dropdownName];
      if (!dropdown) return prev;
      const isSelected = dropdown.selected.includes(String(value.id));
      const inSelectedText = dropdown.selectedText.includes(String(value.name));
      const newSelected = isSelected
        ? dropdown.selected
            .filter((item) => item !== String(value.id))
            .map(String)
        : [
            ...dropdown.selected.filter((item) => item !== String(value.id)),
            String(value.id),
          ];

      const newSelectedText = inSelectedText
        ? dropdown.selectedText
            .filter((item) => item !== String(value.name))
            .map(String)
        : [
            ...dropdown.selectedText.filter(
              (item) => item !== String(value.name)
            ),
            String(value.name),
          ];
       return {
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...dropdown,
            selected: newSelected,
            selectedText: newSelectedText,
          },
        },
      };
    });
    if (dropdownState.dropdowns.DESIGNATIONS.selected.length > 0) {
      setInputs((prevInputs) => ({ ...prevInputs, reporting: inputs.reporting }));
    }
    else{
      setInputs((prevInputs) => ({ ...prevInputs, reporting: "" }));
    }
    if(dropdownState.dropdowns.DESIGNATIONS.selected.includes('2')){
      inputs.reporting='';
      setInputs((prevInputs) => ({ ...prevInputs, reporting: "" }));
    }

    setMatchingObject("");
  };

  const handleClickOutside = (event) => {
    // Check if the click is outside all dropdowns
    const isClickInsideDropdown = Object.values(dropdownRefs.current).some(
      (ref) => ref?.contains(event.target)
    );
    if (!isClickInsideDropdown) {
      setActiveDropdown(null);
    }
  };

  const handleReportingBlur = () => {
    if (!inputs.reporting) {
      setValidReportingTo(false);
    }
  };

  const handleReportingChange = (value) => {
    const data = allreportingData.find((obj) => obj.name === value)?.id;
    setMatchingObject(data);
    setInputs((prevInputs) => ({ ...prevInputs, reporting: value }));
    setValidReportingTo(!!value);
  };

  const handleRole=(type, value)=>{ 
    setRoleValue(value);
    setSelectedRole({
      isSysAdmin: value === 'sys_admin',
      isInternalUser: value === 'internalUser',
      isHopUser: value === 'hopUser'
    });
  }

  useEffect(()=>{
    if(roleValue === 'sys_admin'){
      dropdownState.dropdowns.CLUSTERS.selected.length=0;
      dropdownState.dropdowns.DESIGNATIONS.selected.length=0;
      //dropdownState.dropdowns.DESIGNATIONS.selected=['1'];
      dropdownState.dropdowns.DESIGNATIONS.selectedText.length=0;
      dropdownState.dropdowns.CLUSTERS.selectedText.length=0;
      setMatchingObject("");
    }
    else if(roleValue === 'internalUser'){
      const filteredValues=dropdownState.dropdowns.CLUSTERS.selected.filter((item) => item !== '1');
      dropdownState.dropdowns.CLUSTERS.selected=filteredValues;
      dropdownState.dropdowns.DESIGNATIONS.selected.length=0;
      dropdownState.dropdowns.DESIGNATIONS.selectedText.length=0;
      dropdownState.dropdowns.CLUSTERS.selectedText.length=0;
    }
    else if(roleValue === 'hopUser'){
      const filteredValues=dropdownState.dropdowns.CLUSTERS.selected.filter((item) => item !== '1');
      dropdownState.dropdowns.CLUSTERS.selected=filteredValues;
      dropdownState.dropdowns.DESIGNATIONS.selected.length=0;
      dropdownState.dropdowns.DESIGNATIONS.selectedText.length=0;
      setMatchingObject("");
    }

  },[roleValue])

  useEffect(() => {
    dropdownState.dropdowns.DESIGNATIONS.selected.length === 0 ? setValidDesignation(false) : setValidDesignation(true);
    dropdownState.dropdowns.CLUSTERS.selected.length === 0 ? setValidCluster(false) : setValidCluster(true);
  }, [dropdownState.dropdowns.DESIGNATIONS.selected, dropdownState.dropdowns.CLUSTERS.selected]);

  return (
    <div className="add-user-container">
      <GenericHeader
        title={Globals.ADD_NEW_USER}
        onClose={() => {
          openPopUp("abort");
        }}
      />
      <div className="add-user-content">
        <div className="add-user-form">
          <div className="add-user-title">
            {Globals.ADD_NEW_CLUSTER_BASIC_INFO}
          </div>
          <div className="add-new-user-wrapper">
            <div id="add-user-details-row-1" className="row3-add-user">
              <div className="add-user-score-holder">
                <label id="add-user-region-label" className="add-user-label">
                  {Globals.ADD_NEW_USER_NAME_TITLE}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <input
                  type="text"
                  id="proposal-title-input"
                  value={inputs.name}
                  className={`adduser-input ${
                    inputs.name && inputs.name.length > 0 ? "hightlight" : ""
                  }`}
                  placeholder={Globals.SIGNUP.NAME_INP_PLACEHOLDER}
                  onChange={handleUserName}
                  tabIndex={2}
                  onBlur={handleUserName}
                  maxLength={30}
                ></input>
                {isNameInvalid && (
                  <div>
                    <img
                      id="login-error"
                      className="login-error"
                      src={Globals.IMG.ERROR}
                      alt="password error"
                    />
                    <label className="invalidadduserCredential">
                      {inputs.name.trim().length === 0
                        ? Globals.ERROR_MESSAGES.EMPTY_NAME
                        : Globals.ERROR_MESSAGES.INVALID_NAME}
                    </label>
                  </div>
                )}
              </div>
              <div className="add-user-score-holder">
                <label id="add-user-region-label" className="add-user-label">
                  {Globals.ADD_NEW_USER_EMAIL_TITLE}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <input
                  type="text"
                  id="proposal-title-input"
                  className={`adduser-input  ${
                    inputs.email && inputs.email.length > 0 ? "hightlight" : ""
                  }`}
                  placeholder={Globals.ADD_NEW_USER_EMAIL_PLACEHOLDER}
                  onChange={validateEmail}
                  onBlur={validateEmail}
                  value={inputs.email}
                  required
                  tabIndex="2"
                ></input>
                {!validMail && (
                  <div>
                    <img
                      id="login-error"
                      className="login-error"
                      src={Globals.IMG.ERROR}
                      alt="password error"
                    />
                    <label className="invalidadduserCredential">
                      {errorMessage}
                    </label>
                  </div>
                )}
              </div>
            </div>

            <div id="add-user-details-row-2" className="row3-add-user">
              <div className="add-user-score-holder">
                <label id="add-user-genre-label" className="add-user-label">
                  {Globals.ADD_NEW_USER_PHONE_NUMBER}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <input
                  type="tel"
                  pattern="[0-9+]+"
                  id="proposal-title-input"
                  className={`adduser-input ${
                    inputs.phoneNumber && inputs.phoneNumber.length > 0
                      ? "hightlight"
                      : ""
                  }`}
                  placeholder={Globals.SIGNUP.PHONE_NUMBER_INP_PLACEHOLDER}
                  onChange={handlePhoneNumber}
                  onBlur={checkForEmptyNumber}
                  tabIndex={6}
                  maxLength={inputs.phoneNumber.charAt(0) === "+" ? 16 : 15}
                ></input>
                {isPhoneInValid && (
                  <div>
                    <img
                      id="adduser-error"
                      className="adduser-error"
                      src={Globals.IMG.ERROR}
                      alt="phone number error"
                    />
                    <label className="invalidadduserCredential">
                      {inputs.phoneNumber.length > 0
                        ? Globals.ERROR_MESSAGES.INVALID_PHONE_NUMBER
                        : Globals.ERROR_MESSAGES.EMPTY_PHONE_NUMBER}
                    </label>
                  </div>
                )}
              </div>
              <div className="add-user-score-holder">
                <label id="add-user-genre-label" className="add-user-label">
                  {Globals.ADD_NEW_USER_LOCATION}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <input
                  type="text"
                  id="proposal-title-input"
                  className={`adduser-input  ${
                    inputs.location && inputs.location.length > 0
                      ? "hightlight"
                      : ""
                  }`}
                  placeholder={Globals.ADD_NEW_USER_LOCATION_PLACEHOLDER}
                  onChange={handleLocation}
                  onBlur={handleLocation}
                  value={inputs.location}
                  required
                  tabIndex="7"
                ></input>
                {isLocationInvalid && (
                  <div>
                    <img
                      id="login-error"
                      className="login-error"
                      src={Globals.IMG.ERROR}
                      alt="password error"
                    />
                    <label className="invalidadduserCredential">
                      {Globals.ERROR_MESSAGES.EMPTY_LOCATION}
                    </label>
                  </div>
                )}
              </div>
            </div>

            <div id="add-user-details-row-3" className="row3-add-user">
              <div className="add-user-score-holder">
                <label id="add-user-sctipted-label" className="add-user-label">{Globals.ROLE}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <div className="sa-add-users-radio-btn-group">
                  <label className="role-selection-radio-label-add-user conditional-upload-radio-label">
                    <input type="radio"
                      className="role-selction-radio-buttons"
                      name={Globals.INTERNAL_USERS_ROLE_LIST}
                      checked={selectedRole.isInternalUser}
                      value="1"
                      onClick={() => handleRole(1, 'internalUser')}
                    />
                    {Globals.INTERNAL_USERS_ROLE_LIST}
                  </label>
                  <label className="role-selection-radio-label-add-user conditional-upload-radio-label">
                    <input type="radio"
                      className="role-selction-radio-buttons"
                      name={Globals.HOP_CHANNEL_HEAD_ROLE_LIST}
                      checked={selectedRole.isHopUser}
                      value="2"
                      onClick={() => handleRole(2, 'hopUser')}
                    />
                    {Globals.HOP_CHANNEL_HEAD_ROLE_LIST}
                  </label>
                  <label className="role-selection-radio-label-add-user conditional-upload-radio-label">
                    <input type="radio"
                      className="role-selction-radio-buttons"
                      name={Globals.SYS_ADMIN_ROLE}
                      checked={selectedRole.isSysAdmin}
                      value="3"
                      onClick={() => handleRole(3, 'sys_admin')}
                    />
                    {Globals.SYS_ADMIN_ROLE}
                  </label>
                </div>
              </div>
            </div>

            {selectedRole.isInternalUser&&<div id="add-user-details-row-3" className="row3-add-user">
              <div className="add-user-score-holder">
                <label id="add-user-sctipted-label" className="add-user-label">
                  {Globals.ADD_NEW_USER_DESIGNATION_TITLE}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                  <CheckboxDropDown
                    isOpen={activeDropdown==="DESIGNATIONS"}
                    options={allRoleList}
                    onToggle={() => handletog('DESIGNATIONS')}
                    onSelectAll={(selectAll, options) =>
                      handleSelectAll("DESIGNATIONS",selectAll, options)
                    }
                    onSelect={(value)=>handleSelect("DESIGNATIONS", value)}
                    selectedValues={dropdownState.dropdowns.DESIGNATIONS.selected}
                    title={Globals.ADD_NEW_USER_DESIGNATION_PLACEHOLDER}
                    selectedItems={dropdownState.dropdowns.DESIGNATIONS.selectedText}
                    className={"add-user-dropdown"}
                    outerDivClassName={`${
                      dropdownState.dropdowns.DESIGNATIONS.selected.length>0 ? "active" : ""
                    } addUserDropdownSize`}
                    dropdownRef={(el) =>
                      (dropdownRefs.current[
                        Globals.ADD_NEW_USER_DESIGNATION_TITLE
                      ] = el)
                    }
                    fontColor={"selected-country"}
                    oneWordText={true}
                  />
                {(isDesignationVisited&& !validDesignation) && (
                  <div>
                    <img
                      id="login-error"
                      className="login-error"
                      src={Globals.IMG.ERROR}
                      alt="password error"
                    />
                    <label className="invalidadduserCredential">
                      {Globals.ERROR_MESSAGES.DESIGNATION}
                    </label>
                  </div>
                )}
              </div>
              {newRoleId && (
                <div className="add-user-score-holder">
                  <label id="add-user-region-label" className="add-user-label">
                    {Globals.ADD_NEW_USER_CLUSTER_TITLE}
                    <span id="mandatory" className="mandatory">
                      {Globals.MANDATORY_FIELD}
                    </span>
                  </label>
                  <CheckboxDropDown
                    isOpen={activeDropdown==="CLUSTERS"}
                    options={allClusterList}
                    onToggle={() => handletog('CLUSTERS')}
                    onSelectAll={(selectAll, options) =>
                      handleSelectAll("CLUSTERS",selectAll, options)
                    }
                    onSelect={(value)=>handleSelect("CLUSTERS", value)}
                    selectedValues={dropdownState.dropdowns.CLUSTERS.selected}
                    title={Globals.ADD_NEW_USER_CLUSTER_REGION_PLACEHOLDER}
                    selectedItems={dropdownState.dropdowns.CLUSTERS.selectedText}
                    className={"add-user-dropdown"}
                    outerDivClassName={`${
                      dropdownState.dropdowns.CLUSTERS.selected.length ? "active" : ""
                    } addUserDropdownSize`}
                    dropdownRef={(el) =>
                      (dropdownRefs.current[
                        Globals.ADD_NEW_USER_CLUSTER_TITLE
                      ] = el)
                    }
                    fontColor={"selected-country"}
                    oneWordText={true}
                  />
                  {(isClusterVisited && !validCluster) && (
                    <div>
                      <img
                        id="login-error"
                        className="login-error"
                        src={Globals.IMG.ERROR}
                        alt="password error"
                      />
                      <label className="invalidadduserCredential">
                        {Globals.ERROR_MESSAGES.ERROR_CLUSTER}
                      </label>
                    </div>
                  )}
                </div>
              )}
              {(!dropdownState.dropdowns.DESIGNATIONS.selected.includes('2') && ((dropdownState.dropdowns.DESIGNATIONS.selected.length > 0)
                && (dropdownState.dropdowns.CLUSTERS.selected.length > 0))) && (
                <div className="add-user-score-holder">
                  <label
                    id="add-user-sctipted-label"
                    className="add-user-label"
                  >
                    {Globals.ADD_NEW_USER_REPORTING_TO}
                    <span id="mandatory" className="mandatory">
                      {Globals.MANDATORY_FIELD}
                    </span>
                  </label>
                  <DropdownList
                    selectClass={"addnewuserDropdownSize"}
                    placeHolderValue={
                      Globals.ADD_NEW_USER_REPORTING_TO_PLACEHOLDER
                    }
                    options={reportingData}
                    onSelect={handleReportingChange}
                    selectedItem={inputs.reporting}
                    onBlur={handleReportingBlur}
                    required
                    tabIndex="5"
                  />
                  {!validReportingTo && (
                    <div>
                      <img
                        id="login-error"
                        className="login-error"
                        src={Globals.IMG.ERROR}
                        alt="reporting to error"
                      />
                      <label className="invalidadduserCredential">
                        {Globals.ERROR_MESSAGES.ERROR_REPORTINGTO}
                      </label>
                    </div>
                  )}
                </div>
              )}
            </div>}

            {selectedRole.isHopUser &&<div id="add-user-details-row-3" className="row3-add-user">
              {newRoleId && (
                <div className="add-user-score-holder">
                  <label id="add-user-region-label" className="add-user-label">
                    {Globals.ADD_NEW_USER_CLUSTER_TITLE}
                    <span id="mandatory" className="mandatory">
                      {Globals.MANDATORY_FIELD}
                    </span>
                  </label>
                  <CheckboxDropDown
                    isOpen={activeDropdown==="CLUSTERS"}
                    options={allClusterList}
                    onToggle={() => handletog('CLUSTERS')}
                    onSelectAll={(selectAll, options) =>
                      handleSelectAll("CLUSTERS",selectAll, options)
                    }
                    onSelect={(value)=>handleSelect("CLUSTERS", value)}
                    selectedValues={dropdownState.dropdowns.CLUSTERS.selected}
                    title={Globals.ADD_NEW_USER_CLUSTER_REGION_PLACEHOLDER}
                    selectedItems={dropdownState.dropdowns.CLUSTERS.selectedText}
                    className={"add-user-dropdown"}
                    outerDivClassName={`${
                      dropdownState.dropdowns.CLUSTERS.selected.length ? "active" : ""
                    } addUserDropdownSize`}
                    dropdownRef={(el) =>
                      (dropdownRefs.current[
                        Globals.ADD_NEW_USER_CLUSTER_TITLE
                      ] = el)
                    }
                    fontColor={"selected-country"}
                    oneWordText={true}
                  />
                  {(isClusterVisited && !validCluster) && (
                    <div>
                      <img
                        id="login-error"
                        className="login-error"
                        src={Globals.IMG.ERROR}
                        alt="password error"
                      />
                      <label className="invalidadduserCredential">
                        {Globals.ERROR_MESSAGES.ERROR_CLUSTER}
                      </label>
                    </div>
                  )}
                </div>
              )}
            </div>}
          </div>
        </div>
      </div>

      <div className="add-user-footer">
        <div className="add-user-footer-heading">
          <div className="add-user-footer-btn-group">
            <span
              className="cancel-add-user-btn"
              onClick={() => openPopUp("abort")}
            >
              {Globals.HALF_PAGE_BRIEF_DETAILS.CANCEL}
            </span>
            <button
              onClick={() => {
                openPopUp("submit");
              }}
              disabled={!isButtonActivate}
              id="adduser-submit-btn"
              className={`Adduser-btn`}
            >
              {Globals.ADD_NEW_USER_FOOTER_BTN_TITLE}
            </button>
          </div>
        </div>
      </div>
      {popUpState?.open && (
        <PopUp
          onClose={() => setPopUpState({ open: false })}
          text={popUpState.text || ""}
          title={popUpState.title || ""}
          negativeAction={popUpState.negativeAction}
          normalAction={popUpState.normalAction}
          negativeActionText={popUpState.negativeActionText}
          normalActionText={popUpState.normalActionText}
          popupType={popUpState.popupType}
        />
      )}
    </div>
  );
};

export default AddNewUser;
